// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"221":"5f5bd426","302":"567dce84","972":"5f1eadee"}[chunkId] + ".chunk.css";
};